<template>
  <el-dialog
    title="指南"
    :visible.sync="dialogVisible"
    width="560px"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content">
      <p>一、学校未提供校徽或者提供的校徽不清晰，会导致生成的风险公告栏没有校徽，请重新上传高清校徽。上传方式:综合应用—>本校基本信息—>在页面中部使用鼠标滚轮下拉—>点击LOGO编辑上传—>提交。</p>
      <p>二、针对已生成的风险公告栏，请学校在制作前认真核对公告栏内容(学校名称、校徽的清晰度、文字的描述等)。学校若有两栋以上同样功能的建筑，风险公告栏可多个制作，分别安装(如:宿舍、餐厅、教学楼等)</p>  
      <p>三、针对学校餐厅使用的电、天然气、液化石油气、生物燃油，学校可选择性制作安装相应的重大风险告知栏。</p>
	  <p>四、如发现生成的公告栏内容与学校实际情况不符，请致电:13303832289、17335592066。</p>
	</div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="add">确 定</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
export default {
  name: "RiskNoticeDialog",
  components: {},
  props: {
    dialogResize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  created() {},
  mounted() {},
  watch: {
    dialogResize: function(newVal, oldVal) {
      if (newVal) {
        this.dialogVisible = true;
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    // 获取告知模板列表
    // async add() {
    //   let req = {
    //     schoolId: this.$store.state.schoolId,
    //     templateType: this.templateType
    //   };
    //   let res = await this.$Http.creatNoticeTemplate(req);
    //   if (res.code == 200) {
    //     this.$message({
    //       type: "success",
    //       message: "添加成功!"
    //     });
    //     this.handleClose();
    //     this.$emit("getList");
    //   } else if (res.code == 101) {
    //   } else {
    //     this.$message({
    //       type: "error",
    //       message: res.messsage
    //     });
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
    .content {
        font-family: "Roboto", Arial, sans-serif;
        font-size: 15px;
        line-height: 1.5;
        font-weight: 500;
        color: black; /* 设置字体颜色为偏蓝色，可以根据需要调整颜色代码 */
    }
    
    .content p {
        margin-bottom: 10px;
    }
</style>
